module.exports = __webpack_public_path__ + "static/img/trans_overview.1e313157.gif";